import styled from "styled-components";

export const Container = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: ${({ subgrupo }) =>
    subgrupo === "AT_INCORPORACAO" ? "space-between" : "flex-end"};
  align-items: center;
  margin-top: 32px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Button = styled.button`
  width: 260px;
  height: 40px;
  background-color: ${({ editarSolicitacao, colorTheme }) =>
    editarSolicitacao ? colorTheme : "transparent"};
  border: 2px solid ${(props) => props.colorTheme};
  color: ${({ editarSolicitacao, colorTheme }) =>
    editarSolicitacao ? "#ffffff" : colorTheme};
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  justify-content: ${({ savingChanges }) =>
    savingChanges ? "center" : "space-between"};
  align-items: center;
  padding: 0 8px;
  span {
    font-size: 14px;
    font-weight: bold;
    display: block;
    &:last-child {
      font-size: 20px;
    }
  }
  &:hover {
    box-shadow: 0px 0px 8px ${(props) => props.colorTheme};
  }
  @media (max-width: 768px) {
    margin: 16px 0;
  }
  &:disabled {
    color: #d1d1d1;
    border: 2px solid #d1d1d1;
    cursor: auto;
    background-color: transparent;
    &:hover {
      box-shadow: 0px 0px 0px;
    }
  }
`;

export const MensagemErro = styled.div`
  // height: 44px;
  width: 284px;
  p {
    margin: 0;
  }
`;
